import { Deserializable } from '../deserializable';
import { User } from '../interfaces/user';
import { Address } from './address.model';
import { AgentCaseAdministrator } from './agent-case-administrator.model';
import { AgentMortgageClub } from './agent-mortgage-club.model';
import { AgentNote } from './agent-note.model';
import { AgentSecurityQuestion } from './agent-security-question.model';
import { FsaFirm } from './fsa-firm.model';
import { PropositionInterfaceType } from './proposition-interface-type.model';
import { Role } from './role.model';

export class Agent implements User, Deserializable {
  public Firm: FsaFirm;
  public Principal: FsaFirm;
  public IsCaseAdministrator: boolean;
  public IsBusinessWriter: boolean;
  public IsAccessControllerDelegated: boolean;
  public IsInProfileContext: boolean;
  public PasswordToHash: string;
  public ConfirmationPassword: string;
  public ConfirmationEmail: string;
  public ShouldValidatePassword: boolean;
  public IsRoleMandatory: boolean;
  public IsCreatedFromInternal: boolean;
  public IsNew: boolean;
  public PropositionInterfaceType: PropositionInterfaceType;
  public Id: number;
  public AgentID: number;
  public Title: string;
  public FirstName: string;
  public LastName: string;
  public Initials: string;
  public PhoneNumber: string;
  public FaxNumber: string;
  public MobileNumber: string;
  public PreferContactByEmail?: boolean;
  public PreferContactByPost?: boolean;
  public PrincipalFsaReferenceNo?: number;
  public FsaReferenceNo?: number;
  public EmailAddress: string;
  public DateOfRegistration?: Date;
  public DateProcessed?: Date;
  public StatusCode: string;
  public DateCreated?: Date;
  public DateLastUsed?: Date;
  public FailedLoginCount?: number;
  public ChangePasswordAtNextLogon?: boolean;
  public DateStatusChanged?: Date;
  public AddressID?: number;
  public ProposedEmailAddress: string;
  public PropositionID?: number;
  public InterfaceTypeID?: number;
  public AlternativeFirmName: string;
  public EmailConfirmed?: boolean;
  public EmailConfirmationGuid?: string;
  public IsAccountLockedOut?: boolean;
  public ReceiveCaseNotifications?: boolean;
  public RegistrationExpirationDate?: Date;
  public ResetPasswordGuid?: string;
  public ResetPasswordGuidExpirationDate?: Date;
  public DateLastPasswordReset?: Date;
  public FailedSecurityAnswerCount?: number;
  public TimeLoggedOut?: Date;
  public HideNewFeatureVersion?: number;
  public AccessTokenGuid?: string;
  public AllowCaseAdminFunctionality?: boolean;
  public IsAccountSuspended?: boolean;
  public OneTimeTokenGuid?: string;
  public LastUsedSecurityQuestionCode: string;
  public OneTimeTokenAccessAttemptsCount?: number;
  public OneTimeTokenAccessTime?: Date;
  public HasAcceptedPrivacyNotice?: boolean;
  public Address: Address;
  public AgentAgentCaseAdministrators: Array<AgentCaseAdministrator>;
  public CaseAdministratorAgentCaseAdministrators: Array<AgentCaseAdministrator>;
  public AgentMortgageClubs: Array<AgentMortgageClub>;
  public AgentNotes: Array<AgentNote>;
  public AgentSecurityQuestions: Array<AgentSecurityQuestion>;
  public PropositionName: string;
  public Roles: Array<Role>;

  constructor() {
    this.AgentNotes = new Array<AgentNote>();
    this.AgentAgentCaseAdministrators = new Array<AgentCaseAdministrator>();
    this.CaseAdministratorAgentCaseAdministrators = new Array<AgentCaseAdministrator>();
    this.AgentMortgageClubs = new Array<AgentMortgageClub>();
    this.AgentSecurityQuestions = new Array<AgentSecurityQuestion>();
    this.Roles = new Array<Role>();
  }

  public get ContactNumber(): string {
    return this.PhoneNumber;
  }

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.PropositionName = input.Proposition.Name;
    this.AgentNotes = input.AgentNotes
      ? input.AgentNotes.map((agentNote: AgentNote) => new AgentNote().deserialize(agentNote))
      : new Array<AgentNote>();

    this.AgentAgentCaseAdministrators = input.AgentAgentCaseAdministrators
      ? input.AgentAgentCaseAdministrators.map((agentCaseAdministrator: AgentCaseAdministrator) =>
          new AgentCaseAdministrator().deserialize(agentCaseAdministrator)
        )
      : new Array<AgentCaseAdministrator>();

    this.CaseAdministratorAgentCaseAdministrators = input.CaseAdministratorAgentCaseAdministrators
      ? input.CaseAdministratorAgentCaseAdministrators.map((caseAdministrators: AgentCaseAdministrator) =>
          new AgentCaseAdministrator().deserialize(caseAdministrators)
        )
      : new Array<AgentCaseAdministrator>();

    this.AgentMortgageClubs = input.AgentMortgageClubs
      ? input.AgentMortgageClubs.map((agentMortgageClubs: AgentMortgageClub) =>
          new AgentMortgageClub().deserialize(agentMortgageClubs)
        )
      : new Array<AgentMortgageClub>();

    this.AgentSecurityQuestions = input.AgentSecurityQuestions
      ? input.AgentSecurityQuestions.map((agentSecurityQuestions: AgentSecurityQuestion) =>
          new AgentSecurityQuestion().deserialize(agentSecurityQuestions)
        )
      : new Array<AgentSecurityQuestion>();

    this.Roles = input.Roles ? input.Roles.map((roles: Role) => new Role().deserialize(roles)) : new Array<Role>();

    return this;
  }

  public hasPropositionInterfaceFsaPrincipal(): boolean {
    return !!(this.PropositionID && this.InterfaceTypeID && this.FsaReferenceNo && this.PrincipalFsaReferenceNo);
  }
}
